export default __webpack_public_path__ + "static/Крысиные бега_13-6916d31b21a5c6e4d39a575537531838.jpg";